// extracted by mini-css-extract-plugin
module.exports = {"stakeInputWrap":"StakeInputContainer_stakeInputWrap__1xtS1"};